import { useState } from "react";
import { Rocket } from "lucide-react";
import { ProjectCard } from "@/components/ProjectCard";
import { projects, inDevelopment, FILTERS } from "@/data/projects";
import { useSeo } from "@/lib/seo";

export default function OurWork() {
  useSeo({
    title: "Our Work — Product Portfolio",
    description:
      "Explore the HILDRETH TECHNOLOGIES LLC product portfolio: MedPolicyRef, RouteCast, Emergent VPN, Endoscopy Nurse Pro, Patriot News US, and TikHooks2.",
    path: "/our-work",
  });

  const [filter, setFilter] = useState("All");
  const visible = filter === "All" ? projects : projects.filter((p) => p.filter === filter);

  return (
    <div>
      <section className="relative overflow-hidden border-b border-slate-800/70">
        <div className="absolute inset-0 ht-hero-glow" />
        <div className="relative mx-auto max-w-7xl px-5 py-20 sm:px-8">
          <p className="text-sm font-semibold uppercase tracking-wider text-sky-400">
            Our Work
          </p>
          <h1 className="mt-3 max-w-3xl font-display text-4xl font-semibold tracking-tight text-white sm:text-5xl">
            A portfolio of focused, practical products
          </h1>
          <p className="mt-5 max-w-2xl text-lg leading-relaxed text-slate-300">
            HILDRETH TECHNOLOGIES LLC develops software across healthcare,
            medical policy, travel, privacy, digital media, and creator
            technology. Each product solves a specific, real-world problem.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 py-14 sm:px-8">
        {/* Filters */}
        <div
          data-testid="work-filters"
          className="flex flex-wrap gap-2.5"
          role="tablist"
          aria-label="Filter projects by category"
        >
          {FILTERS.map((f) => (
            <button
              key={f}
              data-testid={`filter-${f.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => setFilter(f)}
              aria-pressed={filter === f}
              className={`rounded-full border px-4 py-2 text-sm font-medium transition-colors ${
                filter === f
                  ? "border-sky-500 bg-sky-500 text-[#040B16]"
                  : "border-slate-700 bg-transparent text-slate-300 hover:border-slate-500 hover:text-white"
              }`}
            >
              {f}
            </button>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {visible.map((p) => (
            <ProjectCard key={p.id} project={p} />
          ))}
        </div>

        {/* In development card */}
        {filter === "All" && (
          <div
            data-testid="project-card-in-development"
            className="ht-card mt-6 flex flex-col items-start gap-4 rounded-xl border-dashed p-8 sm:flex-row sm:items-center"
          >
            <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-slate-600/30 to-slate-500/10 text-slate-300">
              <Rocket size={26} />
            </span>
            <div>
              <h3 className="font-display text-xl font-semibold text-white">
                {inDevelopment.name}
              </h3>
              <p className="mt-2 max-w-2xl text-sm leading-relaxed text-slate-400">
                {inDevelopment.description}
              </p>
            </div>
          </div>
        )}
      </section>
    </div>
  );
}
